
import { Participant } from "@/api/dtos";
import useParticipants from "@/hooks/data/useParticipants";
import { createContext } from "react"

export interface IParticipantsContext extends ReturnType<typeof useParticipants> {
}

export const ParticipantsContext = createContext<IParticipantsContext>({
    data: undefined,
    idMap: undefined,
    loading: false,
    validating: false,
    error: undefined,
    mutate: async () => { return undefined },
    refresh: async () => { return undefined }
});

export default ParticipantsContext;